export class Host {
  private host: string = ''

  constructor() {
    if (this.isStaging) {
      this.host = 'dev.listening-event.com'
    } else if (this.isProduction) {
      this.host = 'www.listening-event.com'
    } else {
      this.host = 'localhost:9101'
    }
  }

  private get isStaging(): boolean {
    return (
      this.isWordpressStaging ||
        window.location.host === 'dev.listeningparty.universalmusic.digital' ||
        window.location.host === 'dev.listening-event.com'
    )
  }

  private get isProduction(): boolean {
    return this.isWordpressLive || window.location.host === 'www.listening-event.com'
  }

  private get isWordpressStaging(): boolean {
    return window.location.host === 'plgframework-main.umgmcx.de'
  }

  private get isWordpressLive(): boolean {
    return window.location.host === 'universalmusic.digital'
  }

  private get isDev(): boolean {
    return window.location.hostname === 'localhost'
  }

  public get socket(): string {
    const proto = window.location.protocol === 'https:' ? 'wss' : 'ws'
    return `${proto}://${this.host}`
  }

  public get rest(): string {
    return `${window.location.protocol}//${this.host}`
  }

  public getLoginUrl(artistId: string): string {
    const redirectURI = encodeURIComponent(
      window.location.origin + window.location.pathname + '#/register'
    )
    let url = `${this.rest}/api/auth/spotify/login?redirect_uri=${redirectURI}`

    if (artistId && artistId.length) {
      url += `&artist_id=${artistId}`
    }

    return url
  }

  public get stickerPath(): string {
    if (this.isWordpressLive || this.isWordpressStaging) {
      return '/wp-content/uploads/2020/08/'
    }
    return '/'
  }
}
